<template>
  <div ref="materialSampledata" id="materialSampledata" class="bringins-content">
    <div class="return-btn" @click="returnFunc()">
      <span></span>
    </div>
    <div class="emission">
      <div class="emission-content" :class="{'emission-content-green':styleType == 'typeGreen'}">
        <el-tabs v-model="tabName">
          <!--el-tab-pane label="基本信息" name="basicInfo">
            <div
              v-if="loading"
              :style="{ width: '100%', height: sampledataHeight + 'px' }"
            >
              <check-loading ref="checkLoading" v-if="loading"></check-loading>
            </div>
            <div v-else-if="!loading"></div>
          </el-tab-pane-->
          <el-tab-pane label="料棚全景监控" name="emissionSource">
            <div class="infor_box">
              <div class="infor_inner box">
                <div class="infor_params">
                  <div class="title">
                    <img src="./img/icon_gear_default.png" />
                    <span>基础信息</span>
                  </div>
                  <div class="infor_params_box">
                    <p>
                      <label for="">料棚面积：</label>
                      <span class="infor_params_value">{{ area }}m²</span>
                    </p>
                    <p>
                      <label for="">存放物料：</label>
                      <span class="infor_params_value">{{ materialName }}</span>
                    </p>
                    <p v-for="(item, n) in materialShedDeviceTypeList" v-bind:key="item.lastTypeId + n">
                      <label for="">{{ item.lastType }}：</label>
                      <span class="infor_params_value">{{ item.count }}</span>
                    </p>
                  </div>
                </div>
                <div v-if="loading2" :style="{ width: '100%', height: sampledataHeight + 'px' }">
                  <check-loading ref="checkLoading2" v-if="loading2"></check-loading>
                </div>
                <div v-if="!loading2">
                  <div class="infor_params">
                    <div class="title">
                      <img src="./img/icon_gear_default.png" />
                      <span>VR全景监控</span>
                    </div>

                    <div class="">
                      <div class="monitor">
                        <el-tabs type="border-card" v-model="curVideoNo">
                          <template v-for="(item, n) in shedVideos" v-bind:key="n + '#' + item.videoNo">
                            <el-tab-pane :label="item.videoNo" :name="item.videoNo">
                              <div class="VDMbutton left" @click="left()"></div>
                              <img :src="vdmSwitchSrc ? vdmSwitchSrc : item.videoUrl" class="vdm-image" />
                              <div class="VDMbutton right" @click="right()"></div>
                            </el-tab-pane>
                          </template>
                        </el-tabs>
                      </div>
                    </div>

                    <div class="public-form form_box" style="margin-top: 40px">
                      <el-form :inline="true">
                        <el-form-item label="起止时间">
<!--                          <el-date-picker v-model="timeArr" type="datetimerange" range-separator="-" :disabledDate="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期"
                            @change="date_change">
                            &lt;!&ndash; value-format="yyyy-MM-dd HH:mm"  &ndash;&gt;
                          </el-date-picker>-->
                          <DatePicker
                            :init-width="'420px'"
                            :start-time-str="timeArr[0]"
                            :end-time-str="timeArr[1]"
                            @dateChange="date_change"
                            topPx="50px"
                            dateType="timerange"
                            :currentDateList="timeArr"
                          >
                          </DatePicker>
                        </el-form-item>
                        <el-form-item>
                          <el-button @click="record_check_click">查询</el-button>
                          <el-button @click="record_reset_click">重置</el-button>
                        </el-form-item>
                      </el-form>
                    </div>

                    <div class="" style="margin-top: 20px">
                      <template v-for="(item, n) in videoInfoList" v-bind:key="'videoInfo#' + n">
                        <div style="height: 400px; width: 1600px">
                          <div class="chart" style="height: 400px; width: 1600px" :ref="'chart-' + n"></div>
                        </div>
                      </template>
                    </div>
                    <div class="" style="margin-top: 50px">
                      <dl class="item" v-for="(item, i) in startStopList" v-bind:key="i">
                        <dd>
                          <div class="title">
                            <img class="title-img" src="./img/icon_gear_default.png" />
                            <span class="equipType">治理设备-</span>
                            <span>{{ item.dName }}-{{ item.dType }}</span>
                          </div>
                          <chartBar2 height="135px" width="1600px" :options="item.options" />
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { unref } from "vue";
import chartBar2 from "@/modules/Charts/chartBar2";
import { dateFormat, unwarp } from "@/utils/tools.js";
import checkLoading from "@/modules/checkLoading";
import { DatePicker } from "@/modules/commonDatePicker";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { chartBar2, checkLoading,DatePicker },
  props: {},
  inject: [
    "getMaterialArea",
    "updateMaterialArea",
    "updateInventorySwitch",
    "updateInventoryId",
    "updateLeftRightPart",
    "updateSourceShow",
    "updateEmissionLoading",
  ],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      styleType: "",
      tabName: "emissionSource",
      loading: true,
      loading2: true,
      sampledataHeight: 200,
      materialId: "",
      shedInfo: "",
      area: "",
      materialName: "",
      materialShedDeviceTypeList: [],
      shedVideos: [],
      shedDeviceObj: [],
      timeArr: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      curVideoNo: "",
      videoInfoList: [],
      vdmDeviceList: [],
      vdmDeviceConvertList: [],
      videoLoc: "",
      videoType: "",
      videoNo: "",
      videoChart: {},
      startStopList: [],
      vdmSwitchSrc: "",
    };
  },
  //计算属性 类似于data概念
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    getMaterialArea: {
      handler(newVal, oldVal) {
        this.materialObj = unref(newVal);
        //this.$forceUpdate();
        if (this.materialObj) {
          let that = this;

          if (that.materialObj.type === 1) {
            that.changeBringins();
            $(".bringins-block").css("left", "-25%");
            setTimeout(function () {
              that.getVdmList();
            }, 500);
          }
        }
      },
      deep: true,
    },
    curVideoNo: {
      handler(newVal, oldVal) {
        this.chooseVdm(newVal);
      },
      deep: true,
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = this.$store.state.styleType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    $(this.$refs.materialSampledata).hide();
    this.timeArr = [
      /*dateFormat("YYYY-mm-dd HH:MM:SS", new Date().getTime() - 24 * 3600 * 1000),
      dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),*/
      "2021-04-30 00:10:00",
      "2021-04-30 15:43:00",
    ];
  },
  //方法集合
  methods: {
    pickerOptions(time) {
      if (this.customerId == 1414) {
        return (
          time.getTime() > new Date().getTime() ||
          new Date("2021-07-01 00:00:00").getTime() > time.getTime()
        );
      } else {
        return time.getTime() > new Date().getTime();
      }
    },
    changeBringins() {
      $(this.$refs.materialSampledata).bringins();
    },
    returnFunc() {
      this.updateMaterialArea("");
      this.updateInventorySwitch(false);
      this.updateInventoryId(false);
      this.updateLeftRightPart(false);
      this.updateSourceShow(false);
      this.updateEmissionLoading(false);
      $(".bringins-block").fadeOut(500);
    },
    record_check_click() {
      this.getVdmList();
    },
    record_reset_click() {
      this.timeArr = [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.getVdmList();
    },
    date_change(e) {
      this.timeArr = e;
    },
    async getVdmList() {
      this.loading2 = true;
      this.shedInfo = await this.findShed();
      this.area = this.shedInfo.area;
      this.materialName = this.shedInfo.materialName;
      this.materialShedDeviceTypeList =
        this.shedInfo.materialShedDeviceTypeList;

      this.shedVideos = await this.findshedVideo();
      if (this.shedVideos.length > 0) {
        this.curVideoNo = this.shedVideos[0]["videoNo"];
      }

      this.getShedDevice(this.curVideoNo);
    },
    async getShedDevice(videoNo) {
      this.loading2 = true;
      this.shedDeviceObj = await this.findShedDevice(videoNo);
      this.loading2 = false;
      let vdmDetailResult = this.shedDeviceObj["vdmDetailResult"];
      if (vdmDetailResult && vdmDetailResult.length > 0) {
        this.videoInfoList = vdmDetailResult;
      }
      this.videoInfoChartRender(videoNo);

      let vdmDeviceDetailResult = this.shedDeviceObj["vdmDeviceDetailResult"];
      if (vdmDeviceDetailResult && vdmDeviceDetailResult.length > 0) {
        this.vdmDeviceList = vdmDeviceDetailResult;
      }
      this.startStopListConvert();
    },
    chooseVdm(videoNo) {
      this.getShedDevice(videoNo);
    },
    async findShed(shedId) {
      let findShedUrl = CONFIG.requestName + this.$apiOpt.findShed;
      return this.$apiUtils.get(findShedUrl, {
        customerId: this.$store.state.customerId,
        shedId: 1,
      });
    },
    async findshedVideo() {
      let findShedVideoUrl = CONFIG.requestName + this.$apiOpt.findShedVideo;
      return this.$apiUtils.get(findShedVideoUrl, {
        customerId: this.$store.state.customerId,
        shedId: 1,
      });
    },
    async findShedDevice(videoNo) {
      let findShedDeviceUrl = CONFIG.requestName + this.$apiOpt.findShedDevice;
      return this.$apiUtils.get(findShedDeviceUrl, {
        customerId: this.$store.state.customerId,
        videoNo: videoNo,
        startTime: this.timeArr[0]
          ? this.timeArr[0]
          : this.$moment(new Date().getTime() - 24 * 3600 * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
        endTime: this.timeArr[1]
          ? this.timeArr[1]
          : this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      });
    },
    startStopListConvert() {
      let resultList = [];
      this.vdmDeviceList.forEach((item, n) => {
        let option = {
          dName: item.signalNo,
          dType: item.signalName,
          name: item.signalNo,
          options: {
            name: item.signalNo,
            themeName: "product",
            tooltip: {
              formatter(params) {
                let str = "";
                str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
                if (params[0].value && params[2].value) {
                  //无 (启 会被暂无数据遮住)
                  str += `<div>时间：${params[0].name}</div>`;
                  str += `<div>启停信号：${params[2].seriesName}</div>`;
                } else if (params[0].value && !params[2].value) {
                  //开
                  str += `<div>时间：${params[0].name}</div>`;
                  str += `<div>启停信号：${params[0].seriesName}</div>`;
                } else {
                  //停
                  str += `<div>时间：${params[1].name}</div>`;
                  str += `<div>启停信号：${params[1].seriesName}</div>`;
                }
                str += `</div>`;
                //		params.forEach((item,i)=>{
                //			if()
                //			str+=`<div class="tooltip" style="font-size:30px;line-height:40px;">${item.name}：${item.value}</div>`
                //		})
                return str;
              },
            },
            xdata: [],
            ydata: [[], [], []],
          },
        };

        let tmpList = item.list;
        if (tmpList && tmpList.length > 0) {
          tmpList.forEach((item_) => {
            option.options.xdata.push(
              item_.dateTime != null
                ? item_.dateTime
                : that.$moment(item_.dateTime).format("MM-DD HH:mm")
            );
            option.options.ydata[0].push({ value: 1 }); //用于离线
            option.options.ydata[1].push({ value: item_.value != 0 ? 1 : 0 }); //启 会被暂无数据遮住
            if (item_.value === null) {
              option.options.ydata[2].push({ value: 1 }); //用于显示暂无数据
            } else {
              option.options.ydata[2].push({ value: 0 });
            }
          });
        }
        resultList.push(option);
      });
      this.startStopList = resultList;
    },
    videoInfoChartRender(videoNo) {
      let that = this;
      this.videoInfoList.forEach((item, n) => {
        let deviceNo = item.deviceNo;
        let xData = [];
        let y1Data = [];
        let y2Data = [];
        let pmData = {
          xData: [],
          y1Data: [],
          y2Data: [],
          title: videoNo,
        };
        item.signalDetailList.forEach((_) => {
          pmData.xData.push(_.dateTime);
          pmData.y1Data.push(_.value);
        });
        item.vdmImgList.forEach((v) => {
          let arr = [];
          let tmpTime = v.collectionTime;
          let tmpVal = 0;
          let tmpTimeStemp = that.$moment(tmpTime).valueOf();
          if (pmData.xData && pmData.xData.length == 1) {
            tmpTime = pmData.xData[0];
            tmpVal = pmData.y1Data[0];
          } else if (pmData.xData && pmData.xData.length > 1) {
            tmpTime = pmData.xData[pmData.xData.length - 1];
            tmpVal = pmData.y1Data[pmData.y1Data.length - 1];
            for (let i = 0; i < pmData.xData.length - 1; i++) {
              let cts = that.$moment(pmData.xData[i]).valueOf();
              let nts = that.$moment(pmData.xData[i + 1]).valueOf();

              if (tmpTimeStemp >= cts && tmpTimeStemp < nts) {
                tmpTime = pmData.xData[i];
                tmpVal = pmData.y1Data[i];
                break;
              }
            }
          }
          arr = [
            tmpTime,
            tmpVal ? tmpVal : 0,
            {
              isWarning: v.isAlarm,
              videoTime: tmpTime,
              vdmTdc: tmpVal ? tmpVal : 0,
              happenTime: tmpTime,
              imgUrl: v.imgUrl,
            },
          ];
          pmData.y2Data.push(arr);
        });
        that.$nextTick(function () {
          if (that.videoChart[n] && that.videoChart[n].dispose) {
            that.videoChart[n].dispose();
          }
          that.videoChart[n] = echarts.init(that.$refs["chart-" + n]);
          unwarp(that.videoChart[n]).setOption(that.getOpt(pmData));
          that.bindAlarmPoint(n);
        });
      });
    },
    bindAlarmPoint(n) {
      let that = this;
      that.videoChart[n].on("click", (a) => {
        if (a.value) {
          /*if (a.value[2].imgUrl.toLowerCase().indexOf("mp4") != -1) {
                that.video_box = true;
                that.img_box = false;
              } else {
                that.img_type = false;
                that.img_box = true;
              }*/
          that.vdmSwitchSrc = a.value[2].imgUrl;
          //that.imgUrl = a.value[2].imgUrl;
          that.videoChart[n].setOption({
            series: [
              {
                name: "可见烟尘监测",
                symbolSize: function (value) {
                  if (value[2].imgUrl == that.vdmImgUrl) {
                    return "35";
                  } else {
                    return "25";
                  }
                },
              },
            ],
          });
        }
      });
    },
    getOpt(pmData) {
      let xData = pmData.xData;
      let y1Data = pmData.y1Data;
      let y2Data = pmData.y2Data;
      let videoNo = pmData.title;
      return {
        // color: ["#00FFFF", "#FF9537"],
        title: {
          text: videoNo,
          show: true,
          textStyle: {
            color: "#fff",
          },
        },
        backgroundColor: "transparent",
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            type: "line",
            snap: true,
          },
          backgroundColor: "#000",
          padding: 10,
          textStyle: {
            color: "#fff",
          },
          formatter: function (params) {
            let res;
            if (params[0]) {
              try {
                res = `<span>时间: ${params[0].axisValue}</span></br>`;
                res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${
                  params[0].seriesName == "小时监测" ? "监测值" : "监测值"
                }: ${params[0].value}</span></br>`;
              } catch {}
            }
            for (var i = 1; i < params.length; i++) {
              if (params[i]) {
                try {
                  if (params[i].value[2].isWarning == 0) {
                    // res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${params[0].seriesName}: ${params[1].value[1]}</span></br>`;
                  } else if (params[i].value[2].isWarning == 1) {
                    res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF9537;"></span><span>${params[i].seriesName}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${params[i].value[2].happenTime}</br>&nbsp;&nbsp;&nbsp;&nbsp;监测值：${params[i].value[2].vdmTdc}</span></br>`;
                  }
                } catch {}
              }
            }
            return res;
          },
        },
        legend: {
          icon: "circle",
          left: "40%",
          top: "8%",
          data: [
            { name: "小时监测", icon: "circle" },
            { name: "可见烟尘监测 ", icon: "circle" },
          ],
          formatter: function (name) {
            return name;
          },
          itemWidth: 20,
          itemHeight: 20,
          textStyle: {
            fontSize: 14,
            color: "rgba(255,255,255,0.6)",
            padding: [2, 0, 0, 0],
          },
          selectedMode: false,
        },
        grid: {
          top: "25%",
          left: "5%",
          right: "6%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                color: "grey",
                width: 0.1,
              },
            },
            boundaryGap: true,
            axisLabel: {
              textStyle: {
                color: "#b1b6b7",
                fontSize: 12,
                margin: 15,
              },
            },
            axisTick: {
              show: false,
            },
            data: xData,
          },
        ],
        yAxis: [
          {
            name: "单位：mg/m³",
            nameTextStyle: {
              fontSize: 14,
              color: "#A6CAFF",
              padding: [0, 0, 0, 20],
            },
            type: "value",
            // min: function (data) {
            //  let minData
            //  minData = data.min * 0.9;
            //  minData = minData > 0.1 ? minData.toFixed(2) : 0
            //  return minData
            // },
            // // Interval:5,
            // max: function (data) {
            //  let maxData
            //  maxData = data.max * 1.1;
            //  maxData = maxData.toFixed(2)
            //  return maxData
            // },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#1E5389",
                width: 1,
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#1E5389",
                width: 1,
              },
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                color: "#b1b6b7",
                fontSize: 12,
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "小时监测",
            type: "line",
            smooth: true,
            symbolSize: 0,
            lineStyle: {
              normal: {
                width: 3,
                color: "#00FFFF",
              },
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.RadialGradient(
                  0.5,
                  0.5,
                  0.5,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 255, 255, 1)",
                    },
                    {
                      offset: 0.6,
                      color: "rgba(0, 255, 255, 1)",
                    },
                    {
                      offset: 0.6,
                      color: "rgba(0, 255, 255, 0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 255, 255, 0.5)",
                    },
                  ],
                  false
                ),
              },
            },
            data: y1Data,
          },
          {
            name: "可见烟尘监测",
            type: "scatter",
            legendHoverLink: true,
            symbolSize: 25,
            itemStyle: {
              color: function (value) {
                if (value.value[2].isWarning == 0) {
                  let v = new echarts.graphic.RadialGradient(
                    0.5,
                    0.5,
                    0.5,
                    [
                      {
                        offset: 0,
                        color: "rgba(0, 255, 255, 1)",
                      },
                      {
                        offset: 0.6,
                        color: "rgba(0, 255, 255, 1)",
                      },
                      {
                        offset: 0.6,
                        color: "rgba(0, 255, 255, 0.5)",
                      },
                      {
                        offset: 1,
                        color: "rgba(0, 255, 255, 0.5)",
                      },
                    ],
                    false
                  );
                  return v;
                } else {
                  let v = new echarts.graphic.RadialGradient(
                    0.5,
                    0.5,
                    0.5,
                    [
                      {
                        offset: 0,
                        color: "rgba(255, 149, 55, 1)",
                      },
                      {
                        offset: 0.6,
                        color: "rgba(255, 149, 55, 1)",
                      },
                      {
                        offset: 0.6,
                        color: "rgba(255, 149, 55, 0.5)",
                      },
                      {
                        offset: 1,
                        color: "rgba(255, 149, 55, 0.5)",
                      },
                    ],
                    false
                  );
                  return v;
                }
              },
            },
            data: y2Data,
            // markPoint: {
            //  data: [
            //   { type: 'max', name: '最大值' },
            //   { type: 'min', name: '最小值' }
            //  ]
            // },
          },
          {
            name: "可见烟尘监测 ",
            type: "scatter",
            legendHoverLink: true,
            symbolSize: 25,
            itemStyle: {
              color: new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                ],
                false
              ),
            },
            data: [],
          },
        ],
      };
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.emission {
  position: relative;
  width: 100%;
  height: 100%;

  .VDMbutton {
    width: 40px;
    height: 60px;
    cursor: pointer;
  }
  .left {
    background-image: url(img/leftBut.png);
    background-size: 100% 100%;
  }
  .right {
    background-image: url(img/rightBut.png);
    background-size: 100% 100%;
  }

  .el-tabs__content {
    position: absolute !important;
    top: 120px !important;
    bottom: 50px !important;
    left: 50px !important;
    right: 30px !important;
    overflow: auto !important;
  }
}

.emission {
  .monitor {
    //@include bg-box(560px, 230px, "1.png");
    //margin: 29px auto 15px;
    position: relative;
    bottom: 10px;
    top: 60px;
    left: 20px;
    right: 20px;

    .el-tabs--border-card {
      background: initial !important;
      border: initial !important;
    }

    .el-tabs--border-card > .el-tabs__header {
      background: initial !important;
      border: initial !important;
    }

    .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      background: #2dacd24d !important;
      border: initial !important;
      color: #65f5f2 !important;
      font-family: "normalFont";
    }

    .el-tabs__content {
      position: relative !important;
      padding: 15px 0;
      width: 100%;
      overflow: auto;
      top: 0px !important;
      left: 5px !important;
      right: 0px !important;
      .vdm-image {
        width: 100%;
      }
    }
  }
}

.emission-content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url(/static/img/img_bg.png);
  background-size: 100% 100%;
  padding: 25px 25px;
  font-size: 12px;
}
.emission-content-green {
  background: url(/static/img/img_bg_green.png);
  background-size: 100% 100%;
}

.emission .el-tabs__item {
  color: #fff !important;
  font-size: 32px !important;
  line-height: 80px;
  height: 80px;
  padding: 0 30px 0 30px !important;
}

.emission .el-tabs__item.is-active {
  color: #3fad92 !important;
  font-size: 32px !important;
  line-height: 80px;
  height: 80px;
  padding: 0 30px 0 30px !important;
}

.return-btn {
  background-image: url("/static/img/return.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 160px;
  height: 50px;
  position: absolute;
  top: 26px;
  right: 50px;
  z-index: 1;
  cursor: pointer;
}

.return-btn > span {
  font-size: 30px;
  left: 80px;
  top: 6px;
  position: relative;
}

.equipType {
  font-size: 24px;
  line-height: 24px;
  color: #3fad92;
}

.title-img {
  display: inline-block;
  vertical-align: middle;
  margin-right: 15px;
}

.title span {
  font-size: 24px;
  line-height: 24px;
}
</style>

<style lang="scss" scoped="scoped">
.title {
  padding: 10px 0;
  img {
    vertical-align: middle;
  }
  span {
    color: #3fad92;
    font-size: 28px;
    vertical-align: middle;
  }
}
/*.information{*/
.infor_box {
  width: 100%;
  /*max-height: 1075px;*/
  display: flex;
  .infor_inner {
    width: 90%;
    .infor_params,
    .infor_zhili {
      position: relative;
      margin-bottom: 30px;
      .infor_params_title {
        font-size: 36px;
        &:before {
          content: "";
          width: 22px;
          height: 23px;
          background: rgba(61, 223, 226, 1);
          border-radius: 50%;
          position: absolute;
          top: 12px;
          left: -40px;
        }
      }
      .infor_params_box {
        color: #cadbe5;
        display: flex;
        flex-wrap: wrap;
        p {
          width: 33%;
          line-height: 40px;
          /*margin-bottom: 16px;*/
          display: flex;
          flex-wrap: wrap;
          label {
            font-size: 20px;
          }
          span {
            display: inline-block;
            width: 44%;
            margin-right: 30px;
            margin-bottom: 16px;
            color: #ccc;
            font-size: 18px;
            span {
              color: #3ddfe2;
              font-size: 20px;
            }
          }
          .infor_params_value {
            color: #3ddfe2;
            font-size: 20px;
          }
        }
      }
      .jiance_params_box {
        display: flex;
        flex-direction: column;
        p {
          width: 100%;
          label {
            width: 100%;
            display: block;
            margin-bottom: 16px;
          }
        }
      }
    }
    .infor_zhili {
      .infor_params_box {
        color: #cadbe5;
        display: block;
        p {
          width: 100%;
          display: flex;
          line-height: 40px;
          label {
          }
          span {
            line-height: 70px;
            span {
              color: #3ddfe2;
            }
          }
        }
      }
    }
  }
  .img_inner {
    //@include bg-box(100%, 400px, "img_iframe.png");
    padding: 4px;
    height: 70%;
    /*width: 40%;*/
    img {
      width: 100%;
      height: 100%;
      &:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }
  }
  .img_p {
    line-height: 40px;
    text-align: center;
  }
}

img {
  display: inline-block;
}
</style>
